








































































































































































































































import {Component} from "vue-property-decorator"
import Vue from "vue"
import JdiContent from "@/components/JdiContent.vue"

import JdiHeading from "@/components/JdiHeading.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsToolbar from "@/design-system/patterns/JdsToolbar.vue"
import JdiDoNot from "@/components/JdiDoNot.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import JdiDocs from "@/components/JdiDocs.vue"

@Component({
    components: {JdiDocs, JdsGlyph, JdiDoNot, JdsToolbar, JdiPreview, JdsButton, JdiStatus, JdiHeading, JdiContent}
})
export default class Button extends Vue {
    sizeDemo = 'high';
    disableDemo = false;

    clickLoading = false

    startLoad() {
        this.clickLoading = true

        setTimeout(() => {
            this.clickLoading = false
        }, 1500)
    }
}
